import { Dialog, DialogTitle, ListItem, Paper, useMediaQuery } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AutoSizer } from 'react-virtualized';
import { VariableSizeList } from "react-window";
import mobileBreakpoint from 'utils/mobileBreakpoint';
import { loadsListDialogStyle } from './LoadsListDialogStyle';
import LoadCard from '../../LoadCard';
import EmptyPlaceholder from 'components/EmptyPlaceholder/EmptyPlaceholder';

function LoadsListDialog({
    loads,
    openDialog,
    setOpenDialog,
    title = 'Loads'
}) {
    const classes = loadsListDialogStyle()
    const [selectedLoad, setSelectedLoad] = useState();

    const history = useHistory();

    const isMobile = useMediaQuery(mobileBreakpoint);

    useEffect(() => {
        if (selectedLoad) {
            setSelectedLoad(loads.find(l => l.id == selectedLoad.id))
        }
    }, [loads])

    const openLoad = (load) => {
        console.log('load', load)
        history.push(`/load/group/${load.groupId}`);
    }

    const Row = ({ index, style }) => {
        const load = loads[index];
        return <ListItem style={style} key={load.id} className={`${classes.listItem}`} selected={selectedLoad?.id == load.id} >
            <LoadCard
                isGroup
                showJourney={!isMobile}
                key={load.id}
                load={load}
                onViewClick={() => openLoad(load)}
            />
        </ListItem>
    };

    const getItemSize = (index) => {
        let height = 250;
        const load = loads[index];
        if (load?.loads?.length > 1 || load?.activities?.length > 0) {
            height = 350
        }
        return height;
    }

    return (
        <>
            <Dialog
                onClose={() => {
                    setOpenDialog(false)
                }}
                open={openDialog}
                maxWidth={'lg'}
                fullWidth={true}
            >
                <DialogTitle id={'dialog-title'} >{title}</DialogTitle>

                {!(!!loads?.length) && <EmptyPlaceholder className={classes.listWrapper} />}
                {!!loads?.length &&
                    <Paper className={classes.listWrapper}>

                        <AutoSizer>
                            {({ height, width }) => (
                                <VariableSizeList
                                    className="List"
                                    height={height}
                                    itemCount={loads?.length}
                                    itemSize={getItemSize}
                                    width={width}
                                >
                                    {Row}
                                </VariableSizeList>
                            )}
                        </AutoSizer>
                    </Paper>}
            </Dialog>
        </>
    );
}

export default LoadsListDialog;